import { infiniteQueryOptions } from "@tanstack/react-query";

import { useFetch } from "@/lib/axios.config";
import { PaginationResponse } from "@/shared/types/api.types";
import { ChallengeResponse } from "../types";
import { appConfig } from "@/lib/site-config";
import {
  getNextPageParam,
  getPreviousPageParam,
  initialPageParam,
} from "@/shared/utils/query";

export const useChallenges = (participate?: boolean) => {
  return infiniteQueryOptions({
    queryKey: ["challenges", participate],
    queryFn: async ({ pageParam }) => {
      const response = await useFetch.get<
        PaginationResponse<ChallengeResponse>
      >("/challenges/ChallengeList", {
        params: {
          limit: appConfig.infiniteQueryLimit,
          offset: pageParam,
          participating: participate,
        },
      });

      return response.data;
    },
    initialPageParam: initialPageParam,
    getNextPageParam: getNextPageParam,
    getPreviousPageParam: getPreviousPageParam,
    // Challenges are also managed from Backoffice. Always reload when this
    // screen opens and refresh a visible list so operators' published changes
    // appear without asking a Telegram user to restart the mini-app.
    refetchOnMount: "always",
    refetchInterval: 30_000,
    refetchIntervalInBackground: false,
  });
};
